
import RsaRiepilogoPresenzePage from "./pages/RsaRiepilogoPresenzePage.vue";
export default {
    RsaRiepilogoPresenzePage
};
